import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function hasStartDateValidator(control: FormControl): { [key: string]: any } {
  const date = control.value;
  const hasFormDate = date && date.start;
  return hasFormDate ? null : { startDate: { value: control.value } };
}

export function validatePhoneNumber(control: FormControl): { [key: string]: any } {
  const phoneNumberRegex = new RegExp(`^\\+[0-9]{3}[ .-]?[0-9]{7,}$`);
  const allowedNumber = phoneNumberRegex.test(control.value);
  return allowedNumber ? null : { phoneNumber: { value: control.value } };
}

export function maxWithExceptionValidator(max: number, exception: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
      return null;
    }
    const value = parseFloat(control.value);
    if (!isNaN(value) && value > max && value > exception) {
      return { max: { max: exception, actual: control.value } };
    } else if (!isNaN(value) && value > max && value !== exception) {
      return { maxWithException: { maxWithException: max, actual: control.value } };
    } else {
      return null;
    }
  };
}

function isEmptyInputValue(value: any): boolean {
  return value == null || value.length === 0;
}
